export { SettingsAccountScreen as default } from '@/src/features/settings/ui/screens/SettingsAccountScreen'
